import { createSvgIcon } from '@mui/material'

export const Vip = createSvgIcon(
  <svg
    version='1.0'
    xmlns='http://www.w3.org/2000/svg'
    width='23'
    height='20'
    viewBox='0 0 28 20'
    preserveAspectRatio='xMidYMid meet'
  >
    <g id='vip-svgrepo-com_1_' data-name='vip-svgrepo-com (1)' transform='translate(-2 -6)'>
      <path
        id='Path_488'
        data-name='Path 488'
        d='M27,7H5A2,2,0,0,0,3,9V23a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V9A2,2,0,0,0,27,7Z'
        fill='none'
        stroke='#f5f5f5'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        id='Path_489'
        data-name='Path 489'
        d='M7,13l3,6.5L13,13m3.5,0v6.5m4-2.225h1.48a2.364,2.364,0,0,0,1.721-.75,2.338,2.338,0,0,0,.215-2.932A1.394,1.394,0,0,0,22.776,13H20.5Zm0,0V19.5'
        fill='none'
        stroke='#f5f5f5'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </g>
  </svg>,
  'Vip'
)
